// Copyright 2026 L3montree GmbH and the DevGuard Contributors.
// SPDX-License-Identifier: 	AGPL-3.0-or-later

"use client";

import {
  createContext,
  useContext,
  useEffect,
  type ProviderProps,
} from "react";
import type { OrgContextParams, WithUpdater } from "@/types/view/context";
import { writeLocalStorage } from "@/hooks/useLocalStorage";

const OrganizationContext = createContext<WithUpdater<OrgContextParams>>({
  v: {
    organization: null,
  },
  update: () => {},
});

export const OrganizationProvider = (
  props: ProviderProps<WithUpdater<OrgContextParams>>,
) => {
  useEffect(() => {
    const org = props.value.v.organization;
    if (org && org.id !== "" && org.slug !== "/") {
      writeLocalStorage("lastActiveOrg", org.slug);
    }
  }, [props.value.v.organization]);

  return <OrganizationContext {...props} />;
};
export const useOrganization = () => useContext(OrganizationContext).v;

export const useUpdateOrganization = () =>
  useContext(OrganizationContext).update;
